import { closeX } from './popup.js';
import { $, el } from '../state/store.js';
import { canUseLockedTemplates } from '../services/limits.js';
import { applyTemplate, listTemplates, loadTemplateDoc } from '../services/templates.js';
import { track } from '../services/analytics.js';
import { showBilling } from './billing.js';
import { toast } from './toast.js';

/* TEMPLATES UI — a read-only cousin of ui/presets.js's modal: same
   .authwrap/.authcard/.projlist CSS, its own #templateswrap overlay so it
   can't collide with #authwrap or #presetswrap, but only an Apply action —
   rename/duplicate/overwrite/delete don't mean anything for shipped
   content. Locked rows (not in the free set, and the visitor hasn't ever
   bought a credit pack) show a CTA into billing instead of applying. */

let overlay = null;
function ensureOverlay() {
  if (overlay) return overlay;
  overlay = el('div', 'authwrap hidden');
  overlay.id = 'templateswrap';
  document.body.appendChild(overlay);
  return overlay;
}
const hide = () => ensureOverlay().classList.add('hidden');
const show = () => ensureOverlay().classList.remove('hidden');

export async function showTemplates() {
  const w = ensureOverlay();
  w.innerHTML = '';
  const card = el('div', 'authcard authcard--wide');
  card.appendChild(el('h2', null, 'Inspiration'));
  closeX(card, hide);
  card.appendChild(el('p', 'authnote',
    'A curated starting point — objects and lighting, dropped onto the screen you’ve already calibrated. Your calibration and photo are untouched.'));

  const list = el('div', 'projlist');
  list.appendChild(el('p', 'authnote', 'Loading…'));
  card.appendChild(list);

  const row = el('div', 'authrow');
  const close = el('button', 'btn btn--gh', 'Close');
  close.onclick = hide;
  row.appendChild(close);
  card.appendChild(row);

  w.appendChild(card);
  show();

  const unlocked = canUseLockedTemplates().ok;

  try {
    const templates = await listTemplates();
    list.innerHTML = '';
    for (const t of templates) {
      const item = el('div', 'projitem');
      item.appendChild(el('span', 'projname', t.title));
      const canUse = t.free || unlocked;
      const apply = el('button', 'btn btn--sm ' + (canUse ? 'btn--pri' : 'btn--gh'), canUse ? 'Apply' : 'Buy credits to unlock');
      apply.onclick = async () => {
        if (!canUse) { showBilling(); return; }
        apply.disabled = true;
        try {
          const doc = await loadTemplateDoc(t.slug);
          await applyTemplate(doc);
          hide();
          toast(`Applied “${t.title}”.`);
          track('template_applied', { slug: t.slug, title: t.title });
        } catch (err) {
          toast(err.message || 'Couldn’t apply that template.', true);
        } finally {
          apply.disabled = false;
        }
      };
      item.appendChild(apply);
      list.appendChild(item);
    }
  } catch (err) {
    list.innerHTML = '';
    list.appendChild(el('p', 'authnote', err.message || 'Couldn’t load the template library.'));
  }
}

export function initTemplates() {
  const btn = $('#btnTemplates');
  if (btn) btn.onclick = showTemplates;
}
